// 共通画面が話す Backend の切替。画面は App か System かを知らずに、ここだけを呼ぶ。
// どちらにつなぐかは URL の作品名で決める（constants/works.js の WORK_BACKEND）。
import { useMemo } from "react";
import { isSystemWork } from "constants/works";
import { useUrlParams } from "hooks/useUrlParams";
import { appBackend } from "./app";
import { systemBackend } from "./system";

export const soulBackend = (work) =>
  isSystemWork(work) ? systemBackend(work) : appBackend;

export const useSoulBackend = () => {
  const { work } = useUrlParams();
  return useMemo(() => soulBackend(work), [work]);
};
